import React, { memo } from 'react';
import { Flex } from 'onefaceui-react-components';
import { useDispatch, useSelector } from 'react-redux';

import StatusCaption from 'react/components/StatusCaption';
import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/monitor';
import FilterEquipmentVisibilityPopover from './components/FilterEquipmentVisibilityPopover';

function EquipmentStatusCaption() {
  const dispatch = useDispatch();
  const equipmentFilters = useSelector(
    (state) => state.routeMonitor.equipmentFilters
  );

  function resetEquipmentFilters(isOpen) {
    if (!isOpen) {
      App.Views.Map.addAllMarkers();
    }
  }

  function toggleSelectedType(type) {
    const getUpdatedValues = () => {
      if (equipmentFilters.includes(type)) {
        return equipmentFilters.filter((item) => item !== type);
      }

      return [...equipmentFilters, type];
    };

    dispatch(actionCreators.updateEquipmentFilters(getUpdatedValues()));
  }

  function filterByTruckStatus(type) {
    if (type === 'filterEquipments') return;
    if (!Monet.Session.Maps.mainMap.truckStatusFilter[type]) {
      Monet.Session.Maps.mainMap.truckStatusFilter[type] = true;

      App.Views.Map.addMarkers();
    } else {
      Monet.Session.Maps.mainMap.truckStatusFilter[type] = false;

      App.Views.Map.removeMarkers();
    }

    toggleSelectedType(type);
  }

  const toggleLabel = getResourceTo(
    'permission.tracker.equipment_route_status'
  );
  const options = [
    {
      type: 'moving',
      title: getResourceTo('maps.legend.truckOnAndMoving'),
      captionItemLabelClassname: 'green-label'
    },
    {
      type: 'stopped',
      title: getResourceTo('maps.legend.truckOnAndStopped'),
      captionItemLabelClassname: 'purple-label'
    },
    {
      type: 'noCommunication',
      title: getResourceTo('maps.legend.truckWithoutCommunication'),
      captionItemLabelClassname: 'red-label'
    },
    {
      type: 'turnedOff',
      title: getResourceTo('maps.legend.truckOff'),
      captionItemLabelClassname: 'black-label'
    },
    {
      type: 'filterEquipments',
      children: (
        <FilterEquipmentVisibilityPopover
          data-testid="filterEquipmentsTooltip"
          isOpen={equipmentFilters.includes('filterEquipments')}
          onOpenChange={() => toggleSelectedType('filterEquipments')}
        />
      )
    }
  ];

  return (
    <Flex
      className="caption-info caption-equipment"
      alignItems="center"
      gap={16}
    >
      <StatusCaption
        toggleLabel={toggleLabel}
        options={options.map((option) => ({
          ...option,
          unchecked: !equipmentFilters.includes(option.type)
        }))}
        afterHandleToggle={resetEquipmentFilters}
        onOptionClick={filterByTruckStatus}
      />
    </Flex>
  );
}

export default memo(EquipmentStatusCaption);
